import React from 'react';

interface LogoProps {
  variant?: 'purple' | 'white';
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ variant = 'purple', size = 'md', showText = true }) => {
  const sizes = {
    sm: { icon: 28, text: 20, gap: 8 },
    md: { icon: 36, text: 24, gap: 10 },
    lg: { icon: 48, text: 32, gap: 12 },
  };

  const { icon, text, gap } = sizes[size];
  const fillColor = variant === 'purple' ? '#7B2D8E' : '#FFFFFF';
  const textColor = variant === 'purple' ? '#7B2D8E' : '#FFFFFF';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap }}>
      {/* Logo Icon - Circle with X chevrons */}
      <svg
        width={icon}
        height={icon}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="50" cy="50" r="50" fill={fillColor} />
        {/* Left chevron pointing right > */}
        <path
          d="M30 35L45 50L30 65"
          stroke={variant === 'purple' ? '#FFFFFF' : '#1a1a1a'}
          strokeWidth="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Right chevron pointing left < */}
        <path
          d="M70 35L55 50L70 65"
          stroke={variant === 'purple' ? '#FFFFFF' : '#1a1a1a'}
          strokeWidth="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {/* Logo Text */}
      {showText && (
        <span
          style={{
            fontSize: text,
            fontWeight: 700,
            fontFamily: 'var(--font-heading)',
            color: textColor,
            letterSpacing: '-0.5px',
          }}
        >
          dynami
        </span>
      )}
    </div>
  );
};

export default Logo;


